import { 
    Box,
    Card,
    Stack,
    Grow,
    Typography,
    CardContent,

    Paper,
    Alert,
    Button,
    Table,
    TableContainer,
    TableCell,
    TableRow,
    TableHead,
    TableBody,
    Container
 } from '@mui/material'
import React from 'react'
import { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { CurrencySimbol } from "../../utilities";
import { v4 as uuidv4 } from "uuid";


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));


const PreventivoSingolo = ({DatiPreventivo}) => {

    const [LogoSoc, setLogoSoc] = useState([]);             //TEMPORANEO per logo di test  ù
    const [isDettaglioOpen, setIsDettaglioOpen] = useState(false)  

    useEffect(() => {
        if (JSON.parse(localStorage.getItem("configurazioni")).logoFile512) {
          setLogoSoc(
            JSON.parse(localStorage.getItem("configurazioni")).logoFile512
          );
        }
      }, [])

    const handleButtonClick = () => {
        setIsDettaglioOpen(!isDettaglioOpen);
    };

    function fillImporto(){
    
        return (
          <Alert severity="success" icon={<></>} >

          <TableContainer sx={{ width: 1 }}>
            {/* <strong>Riepilogo merce</strong> */}
            <Table >
              <TableHead>
                <TableRow key={uuidv4()}>
                  <TableCell key={uuidv4()} align="left">Voce</TableCell>
                  <TableCell key={uuidv4()} align="left">Importo &nbsp;({CurrencySimbol(DatiPreventivo.Valuta)})</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                
                  {/* genTableRowsPreventivo()*/ } 
                   {DatiPreventivo.imprighe.map((row) => (
                  <TableRow
                  key={uuidv4()}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="center" style={{borderBottom:"none"}} key={uuidv4()}>
                      {row.Voce}
                    </TableCell>
                    <TableCell align="center" style={{borderBottom:"none"}} key={uuidv4()}>
                      {row.Importo}
                    </TableCell>
  
                  </TableRow>
                ))}
                
                <TableCell align="center" style={{borderBottom:"none"}} key={uuidv4()}>
                  <Typography sx={{fontWeight:'bold'}}>
                    Totale: 
                  </Typography>
                </TableCell>
                <TableCell align="center" style={{borderBottom:"none"}} key={uuidv4()}>
                  <Typography sx={{fontWeight:'bold'}}>
                    {DatiPreventivo.Importo}
                  </Typography>
                </TableCell>     
              </TableBody>
            </Table>
          </TableContainer>
          </Alert>
        );
      }

  return (
    <Alert severity="info" icon={<></>} sx={{ background: (theme) => theme.palette.error.light + "25" , width:"100%"}}>
      <Container key={uuidv4()}>
        <div style={{width:1095}} key={uuidv4()}>
          <Box  sx={{ml:5,mr:2, mt:3, mb:3,overflow:"auto"}} key={uuidv4()}>
            <Stack direction={"column"}>
                <Card  orientation="horizontal" variant="outlined"  >
                  <Stack direction={"row"}>
                    <Item key={uuidv4()}>
                      <Grow
                            in={
                            JSON.parse(localStorage.getItem("configurazioni"))
                            .logoFile512 && LogoSoc.length > 0
                          }
                          style={{ transformOrigin: "0 0 0" }}
                          {...(LogoSoc.length > 0 ? { timeout: 1000 } : {})}
                        >
                        <img
                          src={
                          LogoSoc.length > 0? 
                            JSON.parse(localStorage.getItem("configurazioni")).logoFile512
                            :
                            require("../../static/logo_true.png")
                          }
                          alt={"..."}
                          style={{ width: 100, height: 100 }}
                        />
                      </Grow>
                    </Item>

                          
                    <Item elevation={0} key={uuidv4()}>
                      <CardContent sx={{ml:2}} style={{width:250}}>
                        <Typography gutterBottom variant="h6" component="div">
                          Titolo:
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {DatiPreventivo.Titolo}
                        </Typography>
                      </CardContent>
                    </Item>
                           {/* <Item elevation={0}>
                              <CardContent sx={{ml:2}} style={{width:250}}> 
                                  <Typography gutterBottom variant="h6" component="div">
                                  Reparto:
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                  {DatiPreventivo.Reparto}
                                  </Typography>
                              </CardContent>
                          </Item>

                          <Item elevation={0}>
                              <CardContent sx={{ml:2}} style={{width:110}}> 
                                  <Typography gutterBottom variant="h6" component="div">
                                  Servizio:
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                  {DatiPreventivo.Servizio}
                                  </Typography>
                              </CardContent>
                          </Item> */}
                          
                    <Item elevation={1} key={uuidv4()}>
                      <CardContent sx={{ml:2}} style={{width:405}}> 
                        <Typography gutterBottom variant="h6" component="div">
                          Descrizione:
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {DatiPreventivo.Descrizione}
                        </Typography>
                      </CardContent>
                    </Item>

                    <Item key={uuidv4()}>
                      <CardContent sx={{ml:2}}>
                        <Typography gutterBottom variant="h5" component="div">
                          Totale:
                        </Typography>
                        <Typography variant="h5" color="text.secondary">
                          {DatiPreventivo.Importo}
                        </Typography>
                      </CardContent>
                    </Item>
                  </Stack> 
                </Card>
                <Card sx={{ height:35}}>
        
                  <Box textAlign='center' key={uuidv4()}>
                      <Button 
                          size="small"
                          startIcon={isDettaglioOpen? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                          onClick={handleButtonClick}
                      >
                          dettaglio
                      </Button>
                  </Box>
              </Card>
              {isDettaglioOpen?  (                  
                <Grow in={isDettaglioOpen}> 
                  <Alert severity="success" icon={<></>}>
                      {
                        fillImporto()
                      } 
                  </Alert> 
                </Grow>
              ):(
                <></>
                )
              }
            </Stack>
          </Box>
        </div>
      </Container>
    </Alert>
  )
}

export default PreventivoSingolo